/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.17",
    versionName: "0.2.0-nightly.2026.4.17",
    versionChannel: "nightly",
    buildDate: "2026-04-17T00:17:44.736Z",
    commitHash: "ab131c8bf46cca301599ccfb610d900dd7d8733f",
};
